import { myAxios } from "../utils/serverContextPath";

// =======================================================
// CRUD
// =======================================================

export const postForumReply = (data) => {
    return myAxios.post("forumreply/save/insert", data);
};

export const updateForumReply = (data) => {
    return myAxios.post("forumreply/save/update", data);
};

export const getForumReplyById = (id) => {
    return myAxios.get(`forumreply/getbyid/${id}`);
};

export const getForumReplyAllPage = (
    keyword = "",
    pageNumber = 0,
    itemsPerPage = 10,
    sortList = [],
    sortOrder = "DESC"
) => {

    return myAxios.get("forumreply/getallpage", {
        params: {
            keyword,
            page: pageNumber,
            size: itemsPerPage,
            sortList,
            sortOrder
        }
    });

};

export const getAllForumReply = (
    keyword = "",
    sortList = [],
    sortOrder = "DESC"
) => {

    return myAxios.get("forumreply/getall", {
        params: {
            keyword,
            sortList,
            sortOrder
        }
    });

};

export const deleteForumReply = (id) => {
    return myAxios.delete(`forumreply/delete/${id}`);
};

// =======================================================
// Recherche
// =======================================================

export const findSimilarForumReply = (
    keyword,
    tauxsimilarity = 0.6,
    sortList = [],
    sortOrder = "DESC"
) => {

    return myAxios.get("forumreply/similarity", {
        params: {
            keyword,
            tauxsimilarity,
            sortList,
            sortOrder
        }
    });

};

// =======================================================
// Métier
// =======================================================

export const getForumReplyByForumTopicId = (
    forumtopicId,
    sortList = [],
    sortOrder = "ASC"
) => {

    return myAxios.get(
        `forumreply/getallbyforumTopic/${forumtopicId}`,
        {
            params: {
                sortList,
                sortOrder
            }
        }
    );

};


export const uploadFileToForumReply = (id,index,file) => {
const MAX_SIZE = 20 * 1024 * 1024;

if (file.size > MAX_SIZE) {

    alert(

        `Le fichier "${file.name}" dépasse 20 Mo.`

    );

    return;
}
else
    
    return myAxios.post(
        `forumreply/uploadfile/${id}/${index}`,
        file,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
};

export const downloadFileFromForumReply = (id,index) => {
    return myAxios.get(`forumreply/downloadfile/${id}/${index}`, {
        responseType: "blob",
    });

};